import { useCallback } from "react";

export const useCardAnimation = () => {
  const handleMouseMove = useCallback((e: React.MouseEvent<HTMLDivElement>, element: HTMLDivElement) => {
    const rect = element.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    const xRotation = ((y - rect.height / 2) / rect.height) * 10;
    const yRotation = ((x - rect.width / 2) / rect.width) * 10;

    const gradientX = (x / rect.width) * 100;
    const gradientY = (y / rect.height) * 100;

    element.style.transform = `perspective(1000px) scale(1.02) rotateX(${-xRotation}deg) rotateY(${yRotation}deg)`;

    if (element.className.includes("gradient")) {
      element.style.backgroundPosition = `${gradientX}% ${gradientY}%`;
    }
  }, []);

  const handleMouseLeave = useCallback((element: HTMLDivElement) => {
    element.style.transform = "perspective(1000px) rotateX(0) rotateY(0) scale(1)";
    if (element.className.includes("gradient")) {
      element.style.backgroundPosition = "0% 50%";
    }
  }, []);

  return {
    handleMouseMove,
    handleMouseLeave,
  };
};
